import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const Resume35 = ({
  color = "#000000",
  font = "Arial, sans-serif",
  fontSize = "11px",
  headingSize = "14px",
  pageSize = "A4",
}) => {
  // Helper for Section Headers
  const SectionHeader = ({ title }) => (
    <Box sx={{ 
      mb: 1.5, 
      mt: 3,
    }}>
      <Typography sx={{ 
        fontWeight: "bold", 
        color: color, 
        fontSize: headingSize,
        textTransform: "uppercase",
        letterSpacing: 0.5
      }}>
        {title}
      </Typography>
      <Box sx={{ 
        width: "100%", 
        height: "1px", 
        bgcolor: "#ccc", 
        mt: 0.5 
      }} />
    </Box>
  );

  return (
    <Box sx={{ 
        width: {lg:"210mm",xs:"170mm"},
      minHeight: "297mm", 
      mx: "auto", 
      bgcolor: "#fff", 
      fontFamily: font,
      boxShadow: "0 0 10px rgba(0,0,0,0.1)", 
      p: "20mm",
      position: "relative"
    }}>
      {/* Name and Title Section - Full Width */}
      <Box sx={{ mb: 4, textAlign: "left" }}>
        <Typography variant="h3" sx={{ 
          fontWeight: "bold", 
          color: color, 
          mb: 0.5,
          fontSize: "28px",
          letterSpacing: 0.5,
          textTransform: "uppercase"
        }}>
          LORNA ALVARADO
        </Typography>
        <Typography variant="h6" sx={{ 
          color: "#666", 
          fontWeight: 500, 
          mb: 2,
          fontSize: "16px",
          letterSpacing: 1
        }}>
          Marketing Manager
        </Typography>
      </Box>

      <Grid container spacing={6}>
        {/* Left Column - 30% width (narrower) */}
        <Grid item sx={{width:"200px"}}>
          {/* ABOUT ME Section */}
          <SectionHeader title="ABOUT ME" />
          <Typography sx={{ 
            fontSize: fontSize, 
            color: "#444", 
            mb: 4, 
            lineHeight: 1.5,
            textAlign: "left"
          }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </Typography>

          {/* EDUCATION Section */}
          <SectionHeader title="EDUCATION" />
          <Box sx={{ mb: 4 }}>
            {[
              { 
                degree: "Bachelor of Business Management",
                university: "Wardiere University",
                period: "2016 - 2020"
              },
              { 
                degree: "Bachelor of Business Management",
                university: "Wardiere University",
                period: "2020 - 2023"
              }
            ].map((edu, idx) => (
              <Box key={idx} sx={{ mb: 2.5 }}>
                <Typography sx={{ 
                  fontWeight: "bold", 
                  fontSize: fontSize,
                  color: "#333"
                }}>
                  {edu.degree}
                </Typography>
                <Typography sx={{ 
                  fontSize: fontSize,
                  color: "#666"
                }}>
                  {edu.university}
                </Typography>
                <Typography sx={{ 
                  fontSize: fontSize,
                  color: "#666",
                  fontStyle: "italic"
                }}>
                  {edu.period}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* SKILLS Section */}
          <SectionHeader title="SKILLS" />
          <Box sx={{ mb: 4 }}>
            {[
              "Strategic Marketing",
              "Data Analysis",
              "Digital Marketing",
              "Brand Development",
              "Critical Thinking",
              "Leadership"
            ].map((skill, idx) => (
              <Typography key={idx} sx={{ 
                fontSize: fontSize,
                mb: 0.8,
                color: "#444"
              }}>
                {skill}
              </Typography>
            ))}
          </Box>

          {/* LANGUAGE Section */}
          <SectionHeader title="LANGUAGE" />
          <Box sx={{ mb: 4 }}>
            {["English", "Arabic"].map((lang, idx) => (
              <Typography key={idx} sx={{ 
                fontSize: fontSize,
                mb: 0.8,
                color: "#444"
              }}>
                - {lang}
              </Typography>
            ))}
          </Box>

          {/* REFERENCES Section */}
          <SectionHeader title="REFERENCES" />
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ 
              fontSize: fontSize,
              color: "#444",
              mb: 0.8
            }}>
              - Harumi Kobayashi
            </Typography>
            <Typography sx={{ 
              fontSize: fontSize,
              color: "#666",
              ml: 2,
              mb: 0.5
            }}>
              Wardiere Inc. / CEO
            </Typography>
            <Typography sx={{ 
              fontSize: fontSize,
              color: "#666",
              ml: 2,
              mb: 2
            }}>
              Phone: +123-456-7890
            </Typography>
            
            <Typography sx={{ 
              fontSize: fontSize,
              color: "#444",
              mb: 0.5
            }}>
              - www.reallygreatsite.com
            </Typography>
            <Typography sx={{ 
              fontSize: fontSize,
              color: "#666",
              ml: 2
            }}>
              City, ST 12345
            </Typography>
          </Box>
        </Grid>

        {/* Right Column - 70% width with vertical line (wider) */}
        <Grid item sx={{width:{lg:"400px",xs:"390px"}}}>
          <Box sx={{ 
            position: "relative",
            pl: 4,
            height: "100%"
          }}>
            {/* Vertical separator line */}
            <Box sx={{ 
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              width: "1px",
              bgcolor: "#ddd"
            }} />

            {/* EXPERIENCE Section */}
            <SectionHeader title="EXPERIENCE" />
            <Box sx={{ mb: 4 }}>
              {[
                { 
                  position: "Marketing Executive",
                  company: "Arowai Industries",
                  location: "123 Anywhere St., Any City",
                  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan. In enim nunc, tincidunt ut quam eget, luctus sollicitudin neque. Sed leo nisl, semper ac hendrerit a, sollicitudin in arcu."
                },
                { 
                  position: "Marketing Manager",
                  company: "Arowai Industries",
                  location: "123 Anywhere St., Any City",
                  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan. In enim nunc, tincidunt ut quam eget, luctus sollicitudin neque. Sed leo nisl, semper ac hendrerit a, sollicitudin in arcu."
                },
                { 
                  position: "Marketing Manager",
                  company: "Arowai Industries",
                  location: "123 Anywhere St., Any City",
                  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan. In enim nunc, tincidunt ut quam eget, luctus sollicitudin neque. Sed leo nisl, semper ac hendrerit a, sollicitudin in arcu."
                },
                { 
                  position: "Marketing Assistant",
                  company: "Arowai Industries",
                  location: "123 Anywhere St., Any City",
                  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan. In enim nunc, tincidunt ut quam eget, luctus sollicitudin neque. Sed leo nisl, semper ac hendrerit a, sollicitudin in arcu."
                }
              ].map((exp, idx) => (
                <Box key={idx} sx={{ mb: 3 }}>
                  <Typography sx={{ 
                    fontWeight: "bold", 
                    fontSize: fontSize,
                    color: "#333",
                    mb: 0.5
                  }}>
                    {exp.position}
                  </Typography>
                  <Typography sx={{ 
                    fontSize: fontSize,
                    color: "#666",
                    mb: 1,
                    fontStyle: "italic"
                  }}>
                    {exp.company} | {exp.location}
                  </Typography>
                  <Typography sx={{ 
                    fontSize: fontSize,
                    color: "#444",
                    lineHeight: 1.5
                  }}>
                    - {exp.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Contact Information at bottom (optional) */}
      <Box sx={{ 
        position: "absolute",
        bottom: "15mm",
        left: "20mm",
        right: "20mm",
        borderTop: "1px solid #ccc",
        pt: 1
      }}>
        <Typography sx={{ 
          fontSize: "10px", 
          color: "#666",
          textAlign: "center"
        }}>
          Phone: +123-456-7890 | Email: hello@reallygreatsite.com | Address: 123 Anywhere St., Any City
        </Typography>
      </Box>
    </Box>
  );
};

export default Resume35;
export const resumeMeta = {
  hasPhoto: false,
  columns: 2,
  colorOptions: [
    { value: '#000000', label: 'Black' },
    { value: '#1a237e', label: 'Dark Blue' },
    { value: '#2e7d32', label: 'Dark Green' },
    { value: '#d84315', label: 'Dark Orange' },
    { value: '#6a1b9a', label: 'Purple' }
  ]
};